import { useMemo } from 'react';
import { useOptions } from './useOptions';
import { useRouteParams } from './useRouteParams';
import { PerformancePeriodDTO } from '../types';
import { useInceptionDates } from './useInceptionDates';

export const useInceptionDate = (): string | null => {
  const { accountId, groupId } = useRouteParams();

  const { performancePeriodOptions, portfoliosInception } = useOptions();

  const inceptionDates = useInceptionDates();

  return useMemo(() => {
    if (groupId) {
      return (
        portfoliosInception.groups.find(group => group.id.toString() === groupId)?.inceptionDate ||
        inceptionDates[groupId] ||
        null
      );
    }

    if (accountId) {
      return (
        portfoliosInception.accounts.find(account => account.id.toString() === accountId)
          ?.inceptionDate ||
        inceptionDates[accountId] ||
        null
      );
    }

    const sinceInceptionPeriodOption = performancePeriodOptions.find(
      ({ value }) => value === PerformancePeriodDTO.AllTime,
    );

    /**
     * When we don't have neither a groupId or accountId that means the
     * user is seeing the data for all managed accounts. In that case,
     * consider the inception date from the since inception period contained
     * in the period options dto.
     */
    return sinceInceptionPeriodOption ? sinceInceptionPeriodOption.range.startDate : null;
  }, [
    accountId,
    groupId,
    inceptionDates,
    performancePeriodOptions,
    portfoliosInception.accounts,
    portfoliosInception.groups,
  ]);
};
